import { BaseDialPadButtonContent } from 'features/dial-pad/constants';
import { DialPadButtonValue } from 'features/dial-pad/enums';
import type { DialPadButtonContent } from 'features/dial-pad/interfaces';

export const phoneDealerButtons: DialPadButtonContent[] = [
  BaseDialPadButtonContent[DialPadButtonValue.One],
  BaseDialPadButtonContent[DialPadButtonValue.Two],
  BaseDialPadButtonContent[DialPadButtonValue.Three],
  BaseDialPadButtonContent[DialPadButtonValue.Four],
  BaseDialPadButtonContent[DialPadButtonValue.Five],
  BaseDialPadButtonContent[DialPadButtonValue.Six],
  BaseDialPadButtonContent[DialPadButtonValue.Seven],
  BaseDialPadButtonContent[DialPadButtonValue.Eight],
  BaseDialPadButtonContent[DialPadButtonValue.Nine],
  BaseDialPadButtonContent[DialPadButtonValue.Asterisk],
  BaseDialPadButtonContent[DialPadButtonValue.Zero],
  BaseDialPadButtonContent[DialPadButtonValue.Hash],
];
